import { Lightbulb, AlertTriangle, TrendingUp, Target } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

export default function InsightsPanel({ metrics, oemBreakdown, atRiskParts }) {
  const generateInsights = () => {
    const insights = [];

    // Top OEM insight
    if (oemBreakdown && oemBreakdown.length > 0 && oemBreakdown[0].tariff_cents > 0) {
      const topOem = oemBreakdown[0];
      insights.push({
        type: 'info',
        icon: TrendingUp,
        title: 'Top Exposure',
        message: `${topOem.oem} accounts for ${topOem.percentage.toFixed(1)}% of total tariff exposure ($${(topOem.tariff_cents / 100).toLocaleString()}).`
      });
    }

    // High tariff rate warning
    if (metrics.effective_rate > 5) {
      insights.push({
        type: 'warning',
        icon: AlertTriangle,
        title: 'High Tariff Rate',
        message: `Your effective tariff rate of ${metrics.effective_rate.toFixed(1)}% is above industry average. Consider sourcing alternatives or tariff mitigation strategies.`
      });
    } else if (metrics.effective_rate > 0) {
      insights.push({
        type: 'success',
        icon: Target,
        title: 'Good Position',
        message: `Your effective tariff rate of ${metrics.effective_rate.toFixed(1)}% is within acceptable range.`
      });
    }

    // Parts without calculations
    const partsWithoutCalcs = metrics.total_parts - atRiskParts.length;
    if (partsWithoutCalcs > 0 && metrics.total_parts > 0) {
      insights.push({
        type: 'info',
        icon: Lightbulb,
        title: 'Action Needed',
        message: `${partsWithoutCalcs} of ${metrics.total_parts} parts don't have tariff calculations yet. Run calculations to get complete portfolio analysis.`
      });
    }

    // No data insight
    if (metrics.total_parts === 0) {
      insights.push({
        type: 'info',
        icon: Lightbulb,
        title: 'Get Started',
        message: 'Import your opportunity data to start analyzing tariff impacts across your portfolio.'
      });
    }

    return insights;
  };

  const insights = generateInsights();

  if (insights.length === 0) {
    return null;
  }

  const getColorClasses = (type) => {
    switch (type) {
      case 'warning':
        return 'bg-orange-50 border-orange-200 text-orange-900';
      case 'success':
        return 'bg-green-50 border-green-200 text-green-900';
      default:
        return 'bg-blue-50 border-blue-200 text-blue-900';
    }
  };

  const getIconColor = (type) => {
    switch (type) {
      case 'warning':
        return 'text-orange-600';
      case 'success':
        return 'text-green-600';
      default:
        return 'text-blue-600';
    }
  };

  return (
    <div className="space-y-3">
      {insights.map((insight, idx) => (
        <Card key={idx} className={`${getColorClasses(insight.type)} border`}>
          <CardContent className="pt-4">
            <div className="flex items-start gap-3">
              <div className={`flex-shrink-0 ${getIconColor(insight.type)}`}>
                <insight.icon size={20} />
              </div>
              <div className="flex-1">
                <p className="font-semibold text-sm mb-1">{insight.title}</p>
                <p className="text-sm">{insight.message}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
